import React from "react";
import InputMask from "react-input-mask";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

export const toMaskValue = number => {
	if (!number) return "";
	const digits = String(number).replace(/\D/g, "");
	return digits.startsWith("55") ? digits.slice(2) : digits;
};

export const fromMaskValue = masked => {
	const digits = masked.replace(/\D/g, "");
	return digits ? `55${digits}` : "";
};

// Mask dinâmico: números brasileiros têm 10 dígitos (fixo, e também celular
// quando o WhatsApp devolve o JID sem o nono dígito) ou 11 (celular completo).
// Um mask fixo de 11 posições desalinhava todo número de 10 dígitos — um fixo
// 4132221234 aparecia como "(41) 32221-234". A variante de 10 dígitos mantém
// 11 posições editáveis para que o 11º dígito ainda possa ser digitado; ao
// chegar nele o mask troca para o agrupamento 5-4.
export const maskFor = localDigits =>
	localDigits.replace(/\D/g, "").length > 10
		? "(99) 99999-9999"
		: "(99) 9999-99999";

// O prefixo "+55" fica fora do mask (como adornment) em vez de ser um literal
// dentro dele: quando ele fazia parte do mask, o primeiro dígito do DDD podia
// colidir com o "5" literal do prefixo (ex: DDD 54), fazendo o react-input-mask
// descartar esse dígito ao digitar.
const PhoneMaskInput = ({ value, onChange, error, helperText, label, placeholder, ...rest }) => (
	<InputMask
		mask={maskFor(toMaskValue(value))}
		maskChar=" "
		value={toMaskValue(value)}
		onChange={e => onChange(fromMaskValue(e.target.value))}
	>
		{inputProps => (
			<TextField
				{...inputProps}
				{...rest}
				label={label}
				error={error}
				helperText={helperText}
				placeholder={placeholder || "(98) 99897-7943"}
				variant="outlined"
				margin="dense"
				InputProps={{
					startAdornment: <InputAdornment position="start">+55</InputAdornment>,
				}}
			/>
		)}
	</InputMask>
);

export default PhoneMaskInput;
